import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import styles from "./styles.module.scss";

interface InputProps {
  name?: string;
  dataTestID?: string;
  placeholder: string;
  className?: string;
  parentClassName?: string;
  required?: boolean;
  minLength?: number;
  validatorMessage: string | undefined;
  label?: string;
  onChange: ({
    code,
    number,
    value,
  }: {
    code: string;
    number: string;
    value: string;
  }) => void;
  readOnly?: boolean;
  value?: string;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  showRequired?: boolean;
  disabled?: boolean;
}

const CustomPhoneInput: React.FC<InputProps> = ({
  dataTestID,
  placeholder,
  className,
  parentClassName,
  required,
  minLength,
  validatorMessage,
  label,
  onChange,
  readOnly,
  value,
  onKeyDown,
  showRequired,
  disabled,
  name,
}) => {
  return (
    <>
      <div
        className={`${styles.inputWrapper} ${parentClassName} ${
          validatorMessage ? styles.error : ""
        }`}
      >
        {label && (
          <label className={styles.label}>
            {label}
            {showRequired ? <span className={styles.req}>*</span> : ""}
          </label>
        )}

        <PhoneInput
          country="ng"
          placeholder="Your phone number"
          inputClass={styles.input}
          inputProps={{
            name,
            required: true,
            // autoFocus: true,
          }}
          onChange={(value, country: any, e, formattedValue) => {
            const num = formattedValue.split(" ");
            num.splice(0, 1);
            const cleanNumber = num.join("").replace(/\D/g, ""); // Remove non-digits

            onChange({
              code: `+${country?.dialCode}`,
              number: cleanNumber,
              value: `+${country?.dialCode} ${cleanNumber}`,
            });
          }}
          value={value}
          isValid={(inputNumber, country: any, countries) => {
            // Validate phone number length based on country
            const cleanNumber = inputNumber.replace(/\D/g, "").replace(country?.dialCode || "", "");
            
            // For Nigerian numbers, must be exactly 10 digits
            if (country?.dialCode === '234') {
              return cleanNumber.length === 10;
            }
            
            // For other countries, between 8-15 digits
            if (cleanNumber.length < 8 || cleanNumber.length > 15) {
              return false;
            }
            
            return true;
          }}
        />

        {validatorMessage && (
          <small className={styles.message}>{validatorMessage}</small>
        )}
      </div>
    </>
  );
};
export { CustomPhoneInput };
